export const AUTO_TRACKING_LABELS = {
    deviceCurrentInfo: 'Поточні дані',
    fullDataTrack: 'Трек',
    pausedTracking: 'Призупинити відстеження',
    showVoyageShape: 'Відображати випуск',
    changeMapViewOnLastInfo: 'Переміщати карту до ТЗ при зміні позиції(При умові закритого вікна інформації про стан транспорту)',
}